<template>
  <div class="mobileViewStyle customer-detail">
    <!-- 客户管理-客户详情/编辑（企业微信手机端） -->
    <div class="detail-body">
      <list-card label="基本信息" type="form">
        <data-input label="客户名称" v-model="dataDetail.merchantRemarkName" placeholder="请输入客户名称"/>
        <data-input label="联系电话" v-model="dataDetail.merchantRemarkPhone" placeholder="请输入联系电话"/>
        <!-- 往来类型：1个人 0公司。新建时可选，已存在的客户不可改（与 web 端一致） -->
        <data-input v-if="!isNew" label="往来类型">
          <span class="row-text">{{ contactTypeName(dataDetail.contactType) }}</span>
        </data-input>
        <data-input v-else label="往来类型">
          <mobile-select class="row-select" :clearable="false" v-model="dataDetail.contactType" placeholder="请选择往来类型">
            <mobile-option label="个人" :value="1"/>
            <mobile-option label="公司" :value="0"/>
          </mobile-select>
        </data-input>
        <!-- 客户类型/所属行业/软件类型/客户来源走字典，后端只存 userCode，名称由前端关联 -->
        <data-input label="客户类型">
          <mobile-select class="row-select" v-model="dataDetail.customerType" label-column="dictName" code-column="userCode" :data="customerTypeList" placeholder="请选择客户类型"/>
        </data-input>
        <data-input label="所属行业">
          <mobile-select class="row-select" v-model="dataDetail.industryId" label-column="dictName" code-column="userCode" :data="industryList" placeholder="请选择所属行业"/>
        </data-input>
        <data-input label="是否云客户">
          <mobile-select class="row-select" v-model="dataDetail.cloudType" placeholder="请选择">
            <mobile-option label="是" :value="1"/>
            <mobile-option label="否" :value="0"/>
          </mobile-select>
        </data-input>
        <data-input label="软件类型">
          <mobile-select class="row-select" v-model="dataDetail.softType" label-column="dictName" code-column="userCode" :data="softTypeList" placeholder="请选择软件类型"/>
        </data-input>
        <data-input label="客户来源">
          <mobile-select class="row-select" v-model="dataDetail.sourceDictId" label-column="dictName" code-column="userCode" :data="sourceList" placeholder="请选择客户来源"/>
        </data-input>
        <mobile-partner-wx-bind ref="wxBind" :partner-id="dataDetail.partnerId" :allow-import="isNew"
                                @imported="onWxImported"/>
        <data-input label="联系人" v-model="dataDetail.merchantRemarkContact" placeholder="请输入联系人"/>
        <data-input label="累计金额(元)" v-model="dataDetail.accumulatedAmount" placeholder="新增订阅/续费会自动累加"/>
        <data-input label="客户分类">
          <mobile-select class="row-select" :clearable="false" v-model="dataDetail.partnerCategory" label-column="dictName" code-column="dictCode" :data="customerCategory" type="tree" placeholder="请选择分类"/>
        </data-input>
        <data-input label="地区">
          <mobile-select class="row-select" :clearable="false" v-model="dataDetail.merchantRegion" label-column="name" code-column="id" :data="regionTree" type="tree" placeholder="请选择地区"/>
        </data-input>
        <data-input label="负责人">
          <mobile-employee-select v-model="dataDetail.ownerEmployeeIds" :display-text="dataDetail.ownerEmployeeNames"/>
        </data-input>
      </list-card>

      <!-- 公司客户：银行信息 -->
      <list-card v-if="dataDetail.contactType === 0" label="银行信息" type="form">
        <data-input label="银行账号" v-model="dataDetail.merchantBankAccount" placeholder="请输入银行账号"/>
        <data-input label="银行户名" v-model="dataDetail.merchantBankAccountName" placeholder="请输入银行户名"/>
        <data-input label="开户行" v-model="dataDetail.merchantBankName" placeholder="请输入开户行"/>
        <data-input label="税号" v-model="dataDetail.merchantTaxNumber" placeholder="请输入税号"/>
      </list-card>

      <!-- 个人客户：其它信息 -->
      <list-card v-if="dataDetail.contactType === 1" label="其它信息" type="form">
        <data-input label="生日">
          <mobile-date-select v-model="dataDetail.merchantBirthday" placeholder="请选择日期"/>
        </data-input>
        <data-input label="性别">
          <mobile-select class="row-select" :clearable="false" v-model="dataDetail.merchantGender" placeholder="请选择性别">
            <mobile-option label="男" :value="1"/>
            <mobile-option label="女" :value="2"/>
          </mobile-select>
        </data-input>
        <data-input label="联系地址" v-model="dataDetail.merchantAddress" placeholder="请输入联系地址"/>
        <data-input label="备注" v-model="dataDetail.merchantRemark" placeholder="请输入备注"/>
      </list-card>
    </div>

    <div class="detail-footer">
      <!-- 已存在的客户才能跟进（新建时还没落库，没有可跟进的客户） -->
      <mobile-button v-if="!isNew" @click="toFollow">跟进</mobile-button>
      <mobile-button el-type="primary" @click="saveData">保存</mobile-button>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import ListCard from "@/components/qywx/layout/ListCard.vue";
import DataInput from "@/components/qywx/data/DataInput.vue";
import MobileSelect from "@/components/qywx/data/MobileSelect.vue";
import MobileOption from "@/components/qywx/data/MobileOption.vue";
import MobileEmployeeSelect from "@/components/qywx/data/MobileEmployeeSelect.vue";
import MobileDateSelect from "@/components/qywx/data/MobileDateSelect.vue";
import MobileButton from "@/components/qywx/button/MobileButton.vue";
import MobilePartnerWxBind from "@/components/qywx/partner/MobilePartnerWxBind.vue";
import customerApi from "@/api/normal/common/customerApi";
import commonApi from "@/api/commonApi";
import util from "@/util/util";
import administrativeData from "@/assets/js/administrative.json";
import {
  DICT_CUSTOMER_SOFT_TYPE, DICT_CUSTOMER_TYPE, DICT_INDUSTRY_TYPE, DICT_PARTNER_ORIGIN, contactTypeName
} from "@/views/h5/crm/crmDictionary";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "CD",
  components: {
    MobilePartnerWxBind, MobileButton, MobileEmployeeSelect, MobileDateSelect, MobileOption, MobileSelect, DataInput, ListCard
  },
  data() {
    return {
      dataDetail: {},
      customerCategory: [], // 客户分类
      regionTree: administrativeData, // 行政区划
      // 字典：后端只存 userCode，名称由前端关联（规则12）
      customerTypeList: [],
      industryList: [],
      softTypeList: [],
      sourceList: [],
    };
  },
  computed: {
    // 没有 id 就是新建
    isNew() {
      return !this.route.query.id;
    }
  },
  created() {
    commonApi.queryDictionaryTree("CUSTOMER_CATEGORY").then(list => this.customerCategory = list);
    commonApi.queryUniqueDictionaryList(DICT_CUSTOMER_TYPE).then(list => this.customerTypeList = list || []);
    commonApi.queryUniqueDictionaryList(DICT_INDUSTRY_TYPE).then(list => this.industryList = list || []);
    commonApi.queryUniqueDictionaryList(DICT_CUSTOMER_SOFT_TYPE).then(list => this.softTypeList = list || []);
    commonApi.queryUniqueDictionaryList(DICT_PARTNER_ORIGIN).then(list => this.sourceList = list || []);
    if (this.isNew) {
      this.initNewCustomer();
    } else {
      this.findById(this.route.query.id);
    }
  },
  methods: {
    findById(id) {
      customerApi.findById(id).then(res => {
        this.dataDetail = res;
      });
    },
    // 新建客户：初始化一份空表单
    initNewCustomer() {
      // 负责人默认当前登录人（与 web 端一致）：普通角色只能看到与自己相关的数据，
      // 留空会导致刚建完的客户在列表里查不到
      const employeeId = util.getEmployeeId();
      this.dataDetail = {
        contactType: 1, // 默认个人
        merchantRemarkName: "",
        merchantRemarkPhone: "",
        partnerCategory: "",
        merchantRegion: "",
        merchantBirthday: "",
        merchantGender: "",
        merchantAddress: "",
        merchantRemark: "",
        merchantBankAccount: "",
        merchantBankAccountName: "",
        merchantBankName: "",
        merchantTaxNumber: "",
        ownerEmployeeIds: employeeId,
        ownerEmployeeNames: "",
        contactList: [],
        // crm 扩展字段（字典值存 userCode）
        customerType: "",
        industryId: "",
        softType: "",
        sourceDictId: "",
        merchantRemarkContact: "",
        // cloudType 是后端 Integer，新建留 null；填 "" 会在保存时绑不上
        cloudType: null,
        accumulatedAmount: null,
      };
      if (employeeId) {
        // 补负责人姓名（只用于回显）；用户已经改过负责人就不覆盖
        commonApi.queryEmployeeByIds([employeeId]).then(list => {
          const employee = list && list[0];
          if (employee && this.dataDetail.ownerEmployeeIds === employeeId && !this.dataDetail.ownerEmployeeNames) {
            this.dataDetail.ownerEmployeeNames = employee.employeeName;
          }
        });
      }
    },
    contactTypeName,
    // 去新增跟进，带上当前客户预填（用户仍可重新选）
    // ★ 带的是 partnerId（ba_business_partner.id 档案id）—— 跟进表记的就是它，不是 merchant 行主键
    toFollow() {
      this.router.push({
        path: "/qywx/partner/customer-follow/detail",
        query: {
          partnerId: this.dataDetail.partnerId,
          partnerName: this.dataDetail.merchantRemarkName,
        }
      });
    },
    /** 企业微信客户回填（选择后不保存，提交时再保存客户） */
    onWxImported(contact) {
      if (!contact) {
        return;
      }
      const isCompany = Number(contact.externalType) === 2;
      if (isCompany) {
        this.dataDetail.merchantRemarkName = contact.corpName || contact.userName || "";
        this.dataDetail.merchantRemarkContact = contact.userName || "";
      } else {
        this.dataDetail.merchantRemarkName = contact.userName || "";
        this.dataDetail.merchantRemarkContact = contact.userName || "";
      }
      if (contact.mobile) {
        this.dataDetail.merchantRemarkPhone = contact.mobile;
      }
      this.dataDetail.contactType = isCompany ? 0 : 1;
    },
    saveData() {
      if (!this.dataDetail.merchantRemarkName) {
        this.$message.error("请输入客户名称");
        return;
      }
      // 个人客户的手机号不能为空，与 web 端一致（后端同样有校验）
      if (this.dataDetail.contactType === 1 && !this.dataDetail.merchantRemarkPhone) {
        this.$message.error("个人客户联系电话不能为空");
        return;
      }
      const isNew = this.isNew;
      const payload = JSON.parse(JSON.stringify(this.dataDetail));
      // mobile-select 的「清除」会给出 ""，后端 cloudType 是 Integer、accumulatedAmount 是 BigDecimal，
      // 空串会绑不上导致整个保存失败，这里统一归一成 null
      ["cloudType", "accumulatedAmount"].forEach(k => {
        if (payload[k] === "" || payload[k] === undefined) {
          payload[k] = null;
        }
      });
      // 成功提示由请求拦截器统一弹（save*** 接口），这里不再自己弹
      customerApi.saveCustomer(payload).then(res => {
        // 新建时如果从企业微信导入过客户，保存成功后补关联（关联失败不阻断返回）
        if (isNew && this.$refs.wxBind && res && res.partnerId) {
          return this.$refs.wxBind.bindPending(res.partnerId);
        }
      }).then(() => {
        this.router.back();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.customer-detail{
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--yq-background-color);
  .detail-body{
    flex: 1;
    overflow-y: auto;
    padding: 10px;
  }
  .detail-footer{
    flex: none;
    display: flex;
    gap: 10px;
    padding: 10px;
    background: #FFF;
    box-shadow: 0 -1px 4px var(--yq-shadow);
    :deep(.mobile-button){
      flex: 1;
    }
  }
  // 选择类控件（分类/地区/性别）放在 data-input 行里：去掉自带边框，字号跟随整行
  :deep(.row-select .select-area){
    width: auto;
    box-shadow: none;
    padding: 0;
    background: transparent;
    font-size: inherit;
    color: var(--yq-font-color-base);
    .value{
      flex: none;
      width: auto;
      max-width: 220px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: right;
      &.placeholder{
        color: var(--yq-font-color-desc);
      }
    }
    // 箭头交给 data-input 统一渲染，控件自带的那个关掉，避免一行两个箭头
    .arrow-down{
      display: none;
    }
  }
  // 日期控件：去掉自带边框；去掉左侧的日历图标
  .row-text{
    color: var(--yq-font-color-base);
    &.placeholder{
      color: var(--yq-font-color-desc);
    }
  }
}
</style>
